import { EntityType } from '@frontend/common';
import { CommonMessage, getCorrectTranslation, useLocale } from '@frontend/lang';
import { ProductExtendedClient } from '@frontend/product/api';
import { productRequest } from '@frontend/product/events';
import { IProduct, ProductExtended } from '@frontend/product/types';
import React from 'react';

import { ReactiveDetailRegistryEntry, ReactiveDetailView } from '../../modal/reactive-detail-shell/reactive-detail.types';
import {
    ProductConstraintsSection,
    ProductDetailsCard,
    ProductEquipmentsSection,
    ProductGeneralSection,
    ProductKitItemsSection,
    ProductStockSection,
    isEquipmentProduct,
    isKitProduct
} from './product-detail-sections';

const ProductTitle = ({ view }: { view: ReactiveDetailView<IProduct, ProductExtended> }) => {
    const { locale } = useLocale();
    const product = view.extended ?? view.object;
    return (
        <div>
            <span>{CommonMessage.OBJECTS.PRODUCT.DEFAULT}:</span> <span>{locale ? getCorrectTranslation(locale, product, 'name') : product.name}</span>
        </div>
    );
};

export const productReactiveDetail: ReactiveDetailRegistryEntry<IProduct, ProductExtended> = {
    entityType: EntityType.PRODUCT,
    resolveFunction: productRequest,
    fetchExtended: ({ object }) => ProductExtendedClient.fetchExtendedProduct(object.account_id, object.id),
    modalClassName: 'w-full lg:w-2/3 max-w-[900px]',
    title: (view) => <ProductTitle view={view} />,
    tabs: [
        {
            id: 'general',
            label: CommonMessage.DETAIL.GENERAL,
            render: (view) =>
                view.extended ? (
                    <>
                        <ProductDetailsCard product={view.extended} />
                        <ProductGeneralSection product={view.extended} />
                    </>
                ) : null
        },
        {
            id: 'stock',
            label: CommonMessage.OBJECTS.STOCK.DEFAULT,
            render: (view) => (view.extended ? <ProductStockSection product={view.extended} /> : null)
        },
        {
            id: 'equipments',
            label: CommonMessage.OBJECTS.EQUIPMENT.PLURAL,
            visible: (view) => !!view.extended && isEquipmentProduct(view.extended),
            render: (view) => (view.extended ? <ProductEquipmentsSection product={view.extended} /> : null)
        },
        {
            id: 'items',
            label: CommonMessage.OBJECTS.COMMON_FIELDS.ITEM,
            visible: (view) => !!view.extended && isKitProduct(view.extended),
            render: (view) => (view.extended ? <ProductKitItemsSection product={view.extended} /> : null)
        },
        {
            id: 'constraints',
            label: CommonMessage.OBJECTS.CONSTRAINT.PLURAL,
            render: (view) => (view.extended ? <ProductConstraintsSection product={view.extended} /> : null)
        }
    ]
};
